import { Actions, Ability } from '../Contexts/CaslContext';
import { AppRoutes } from '../Constants/Routes';

interface LandingRule {
  subject: string;
  route: string;
}

// Ordered list of post-login landing candidates. Order mirrors the main
// drawer (`drawerItems.ts` -> DrawerItemsOne) so the destination matches what
// the user sees in the sidebar. First match wins. If a user has no matching
// permission, fall back to /profile (always accessible).
//
// Drawer subjects that aren't in the typed `objects` union (HelpDesk,
// Respond.io, etc.) are kept as plain strings — `ability.can`
// accepts any subject at runtime.
const LANDING_PRIORITY: LandingRule[] = [
  { subject: 'Home', route: AppRoutes.home },
  { subject: 'Report', route: AppRoutes.reports },
  { subject: 'ScrapingOrder', route: AppRoutes.orders },
  { subject: 'PurchaseOrder', route: AppRoutes.purchasedHistory },
  { subject: 'Shipment', route: AppRoutes.shipments },
  { subject: 'Transaction', route: AppRoutes.transactions },
  { subject: 'Offer', route: AppRoutes.paymentMethodDiscounts },
  { subject: 'Refund', route: AppRoutes.refunds },
  { subject: 'User', route: AppRoutes.customers },
  { subject: 'HelpDesk', route: AppRoutes.helpdesk },
  { subject: 'Notification', route: AppRoutes.notifications },
  { subject: 'Message', route: AppRoutes.watcher },
  { subject: 'Respond.io', route: AppRoutes.respondIO },
  { subject: 'Warehouse', route: AppRoutes.warehouses },
  { subject: 'ShippingCompany', route: AppRoutes.shippingCompanies },
  { subject: 'HumanResources', route: AppRoutes.humanResources },
  { subject: 'TimeLeave', route: AppRoutes.timeLeave },
  { subject: 'Management', route: AppRoutes.management },
  { subject: 'DashboardSetting', route: AppRoutes.settings },
  { subject: 'AppSetting', route: AppRoutes.appSettings },
];

export const getFirstAccessibleRoute = (ability: Ability): string => {
  for (const { subject, route } of LANDING_PRIORITY) {
    if (ability.can(Actions.Read, subject as any)) return route;
  }
  return AppRoutes.profile;
};
